<template>
	<NewsMarkets />
</template>

<script setup></script>
